import styled, { DefaultTheme } from 'styled-components';
import { ToastPropsType } from './Toast';

const getBorderColor = (type: ToastPropsType['type'], theme: DefaultTheme) => {
	if (type === 'info') {
		return theme.colors.primary.border.default;
	}

	return theme.colors[type].border.default;
};

export const ToastWrapper = styled.div<{
	type: ToastPropsType['type'];
	hasCloseButton: ToastPropsType['hasCloseButton'];
}>`
	position: relative;
	display: flex;
	align-items: flex-start;
	gap: ${({ theme }) => theme.spacing.small};
	padding: ${({ theme, hasCloseButton }) =>
		`${theme.spacing.small} ${hasCloseButton ? theme.spacing.xl : theme.spacing.medium} ${theme.spacing.small} ${theme.spacing.medium}`};
	border-radius: ${({ theme }) => theme.shapeRadius.xs};
	background: ${({ theme }) => theme.colors.system.background.white};
	border: 1px solid ${({ theme, type }) => getBorderColor(type, theme)};
	width: 100%;
`;

export const ToastIconWrapper = styled.div`
	display: flex;
	justify-content: center;
`;

export const ToastContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacing.xs};
`;

export const ToastTextWrapper = styled.div<{
	inlineLink: ToastPropsType['inlineLink'];
}>`
	display: flex;
	flex-direction: ${({ inlineLink }) => (inlineLink ? 'row' : 'column')};
	gap: ${({ theme, inlineLink }) =>
		inlineLink ? theme.spacing.xs : theme.spacing.xxs};
	white-space: pre-wrap;
`;
